<template>
    <div class="no-print w-full md:w-1/4 lg:w-1/5 flex-shrink-0 md:mr-12 p-4 mb-4 md:mb-0 border border-dividers bg-white">
        <a v-if="hasChangedFilters" class="mb-4" href="#" @click.prevent="resetFilters()">Reset Filters</a>
        <h3 class="text-midwinter-dark--blue text-xl">Filter by:</h3>
        <div>
            <ul class="clean-list list-none p-0 m-0">
                <li v-for="track in sortedAllTracks" :key="track.title">
                    <label class="flex items-center text-text">
                        <input type="checkbox" @change="toggleTrack(track.title)" :value="track.title" :checked="agenda.activeTracks.includes(track.title)">
                        <span class="mx-2">{{ track.title }} </span>
                        <span class="inline-block" :style="{ backgroundColor: track.color, height: '2px', width: '20px' }"></span>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";

const getOrder = () => {
    const trackListContainer = document.querySelector("div.accordion-content ul.conference-track-listing");
    let list = trackListContainer.children;
    let toReturn = [];
    for (let item of list) {
        toReturn.push(item.querySelector("p.conference-track-listing__title").innerText);
    }
    return toReturn;
}


export default {
    data() {
        return {
            trackExpanded: false,
            filterOrder: [],
        };
    },
    computed: {
        ...mapGetters(["allTracks"]),
        ...mapState(["agenda"]),
        hasChangedFilters() {
            return this.agenda.activeTracks.length > 0;
        },
        sortedAllTracks() {
            return this.allTracks.sort((a, b) => {
                let indexA = this.filterOrder.indexOf(a.title) > -1 ? this.filterOrder.indexOf(a.title) : null;
                let indexB = this.filterOrder.indexOf(b.title) > -1 ? this.filterOrder.indexOf(b.title) : null;
                if(indexA != null && indexB != null){
                    if(indexA > indexB) return 1;
                    if(indexA < indexB) return -1;
                }else {
                    if(indexA != null && indexB == null) return -1
                    if(indexA == null && indexB != null) return 1
                }
            });
        }
    },
    created() {
        const order = getOrder();
        this.filterOrder = order;
    },
    methods: {
        ...mapMutations(["toggleTrack", "setType"]),
        ...mapActions(["resetFilters"]),
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/conference-agenda/ConfAgendaFilter.vue